import React from "react";
import { Table } from "react-bootstrap";
import { IconWithTextRecord } from "../../types";

type Props = {
    records: IconWithTextRecord[];
};

const IconWithTextTable = ({ records }: Props) => {
    const old_icons_to_new: Record<string, string> = {
        'ok': 'check',
        'remove': 'x'
    };
    return (
        <Table borderless>
            <tbody>
                {records.map((record, index) => {
                    const span = new DOMParser().parseFromString(record.icon, 'text/html').body.querySelector('span');
                    let icon: { icon: string, color: string } | null = null;
                    if (span) {
                        const match = span.classList[1].match(/glyphicon-(.*)/);
                        if (match) {
                            icon = {
                                icon: old_icons_to_new[match[1]],
                                color: span.style.color
                            }
                        }
                    }
                    return (
                        <tr key={index}>
                            <td>{icon ? <i className={`bi bi-${icon.icon} fs-6`} style={{color: icon.color}}></i> : null}</td>
                            <td>{record.text}</td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    )
};

export default IconWithTextTable;
